import axios from "axios";

let base = process.env.REACT_APP_API_URL || "http://localhost:3001";

// Clean up the base URL
base = base.replace(/\/+$/, ""); // Remove trailing slashes

// Only add /api if it's not already present
if (!base.includes("/api")) {
  base = base + "/api";
}

// Remove any duplicate /api/api patterns
base = base.replace(/\/api\/api/g, "/api");

// Final cleanup to ensure no double slashes
base = base.replace(/\/+/g, "/").replace(/:\//, "://");

const API_BASE_URL = base;

console.log("🔗 API Base URL configured:", API_BASE_URL);

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Ensure cookies are sent
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Preserve skipAuthLogout flag from request config (important: must return config)
    // The skipAuthLogout flag will be available in error.config in response interceptor
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // For blob responses with PDF content type, don't treat as error
    // (some servers return blob with non-200 status but it's still valid PDF)
    if (
      error.config?.responseType === "blob" &&
      error.response?.data instanceof Blob
    ) {
      const contentType = error.response?.headers["content-type"];
      if (contentType && contentType.includes("application/pdf")) {
        // It's a PDF blob - return as success response so caller can handle it
        return Promise.resolve({
          ...error.response,
          data: error.response.data,
        });
      }
      // For non-PDF blob errors, try to parse as JSON if content-type is JSON
      if (contentType && contentType.includes("application/json")) {
        // Will be handled by caller - they can read the blob as text and parse
        return Promise.reject(error);
      }
    }

    if (error.response?.status === 401) {
      const endpoint = (error.config && error.config.url) || "";

      // SIMPLE FIX: NEVER logout on payments/rents endpoints - just return error
      if (endpoint.includes("/payments") || endpoint.includes("/rents")) {
        return Promise.reject(error); // Don't logout, just return error
      }

      // For other endpoints, logout only on critical auth failures
      console.log("🔐 [API] Critical authentication failure, logging out user");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("refreshToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
